import castArray from 'lodash/castArray'
import clone from 'lodash/cloneDeep'

export function setAll (state, data) {
  state.fetched = true
  state.all = data
}

export function setOne (state, data) {
  state.one = clone(data)
}

export function setCreate (state, data) {
  state.one = clone(data)
  if (state.all == null) {
    state.all = []
  }
  state.all.push(clone(data))
}

export function setUpdate (state, data) {
  state.one = clone(data)
  const index = state.all.findIndex(item => item.id === data.id)
  if (index >= 0) {
    state.all.splice(index, 1, data)
  }
}

export function setProperty (state, { id, property, value }) {
  const index = state.all.findIndex(item => item.id === id)
  if (index >= 0) {
    state.all.splice(index, 1, Object.assign({}, state.all[index], { [property]: value }))
  }
  if (state.one && state.one.id === id) {
    state.one = Object.assign({}, state.one, { [property]: value })
  }
}

export function setDestroy (state, id) {
  castArray(id).forEach(id => {
    const index = state.all.findIndex(item => item.id === id)
    if (index >= 0) {
      state.all.splice(index, 1)
    }
  })
}

export function setPagination (state, data) {
  state.pagination = data
}
